import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arc-property-Study",
  "use": "icon-Arc-property-Study-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Arc-property-Study\">\n<path d=\"M9.8419 0.779388V10.4046C9.84261 10.6579 9.66862 10.8827 9.41123 10.961L4.7831 12.3717C4.74256 12.3918 4.72457 12.4371 4.74132 12.477C4.75333 12.5151 4.79218 12.5402 4.83453 12.5372L10.9411 12.1221C11.0713 12.103 11.1677 11.9988 11.1693 11.8754V3.24284C11.171 3.06028 11.3278 2.91222 11.5228 2.90896H12.111C12.3085 2.90896 12.4692 3.05796 12.4709 3.24284V13.1357C12.4692 13.3671 12.2682 13.5538 12.021 13.5538H1.97409C1.72736 13.5538 1.52734 13.3666 1.52734 13.1357V3.63085C1.53186 3.2794 1.77073 2.96811 2.12514 2.85181L9.36944 0.463561C9.55667 0.403577 9.76052 0.49628 9.82583 0.671104C9.83871 0.705928 9.84523 0.742536 9.84511 0.779388H9.8419Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/Arc-property-Study.svg
// module id = j/Vc
// module chunks = 262